import type {
  FormBuilder_Style_PageLayout_Default,
  SessionHydration_Asset_Image,
} from '~/graphql/types';
import getUnionImageUrl from '~/util/getUnionImageUrl';

export type PageLayoutDefault = {
  type: 'default';
  props: {
    backgroundColor: string;
    backgroundImage?: {
      src: string;
    };
  };
};

const formatLayout = (
  input: FormBuilder_Style_PageLayout_Default,
  assets: Array<SessionHydration_Asset_Image>,
): PageLayoutDefault => {
  const backgroundImageUrl = getUnionImageUrl(input.backgroundImage, assets);

  return {
    props: {
      backgroundColor: input.backgroundColor,
      backgroundImage: backgroundImageUrl
        ? { src: backgroundImageUrl }
        : undefined,
    },
    type: 'default',
  };
};

export default formatLayout;
